import React, { useEffect, useState } from "react";
import { Container, Grid, Divider } from "@material-ui/core";
import { config } from "../config/config";
import { withRouter } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  Card,
  CardContent,
} from "@mui/material";

const Schedule = () => {
  const [schedule, setSchedule] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const releaseScheduleTable = (data) => {
    if (data.length > 0) {
      console.log(data);
      return (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((d, i) => (
              <TableRow key={i}>
                <TableCell>{d.release_date}</TableCell>
                <TableCell>{d.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    } else {
      return (
        <Typography variant="p">There are no upcoming releases</Typography>
      );
    }
  };

  useEffect(() => {
    var queryParams = "";
    if (appliedFilters !== undefined) {
      Object.entries(appliedFilters).map(([key, value]) => {
        queryParams += `&${key.toLowerCase()}=${value}`;
        return null;
      });
    }
    if (
      (appliedFilters["startDate"] === undefined &&
        appliedFilters["endDate"] !== undefined) ||
      (appliedFilters["startDate"] !== undefined &&
        appliedFilters["endDate"] === undefined)
    ) {
    } else {
      fetch(config.API_URL + `/Release/schedule`)
        .then((res) => {
          console.log(res);
          return res.json();
        })
        .then((data) => {
          console.log(data);
          setSchedule(data);
          setIsLoading(false);
        });
    }
  }, [appliedFilters]);

  if (!isLoading) {
    if (schedule.length > 0) {
      let fs = schedule[0];
      return (
        <div>
          {/* <h2>Release Schedule coming soon.</h2> */}
          <Container maxWidth="xl">
            <Grid container style={{ marginTop: "75px" }}>
              <Grid item xs={12}>
                <Typography variant="h5" style={{ display: "inline-block" }}>
                  Upcoming Release
                </Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {fs.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" style={{ display: "inline-block" }}>
                  All Scheduled Releases
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {releaseScheduleTable(schedule.shift())}
              </Grid>
            </Grid>
          </Container>
        </div>
      );
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ marginTop: "75px" }}>
            <Typography>No releases have been scheduled</Typography>
          </Grid>
        </Container>
      );
    }
  } else {
    return (
      <Container maxWidth="xl">
        <Grid container style={{ marginTop: "75px", display: "block" }}>
          <Grid item xs={12}>
            <LinearProgress style={{ margin: "0 auto" }} />
          </Grid>
        </Grid>
      </Container>
    );
  }
};

export default withRouter(Schedule);
